import { basicApiReducer } from '@ackee/redux-utils';
import { combineReducers } from 'redux';

import { loadSettings, loadSettingsFailure, loadSettingsSuccess } from '../actions';

const load = basicApiReducer({
    actionTypes: {
        REQUEST: loadSettings.toString(),
        SUCCESS: loadSettingsSuccess.toString(),
        FAILURE: loadSettingsFailure.toString(),
    },
});

export const apiReducer = combineReducers({
    load,
});
